import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { ErrorEstandar } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { PersonasJuridica } from './entity-personas-juridica.model';

export const entityPersonasJuridicaAdapter: EntityAdapter<PersonasJuridica> =
  createEntityAdapter<PersonasJuridica>({
    selectId: (model) => model.id,
    sortComparer: (a: PersonasJuridica, b: PersonasJuridica): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityPersonasJuridicaState
  extends EntityState<PersonasJuridica> {
  isLoading?: boolean;
  error?: ErrorEstandar | null;
}

export const initialState: EntityPersonasJuridicaState =
  entityPersonasJuridicaAdapter.getInitialState({
    isLoading: false,
    error: null
  });
